export const initialState = {
    loading: true,
    document: null
}